import { t as translate } from "i18next";
import * as z from "zod";

export const addOrderAccountSchema = z
	.object({
		email: z.string().trim().email(),
		password: z.string().min(4),
		authType: z.enum(["gauth", "backup_code"]),
		gauth: z.string(),
		backup_code: z.array(z.string().regex(/^\d{8}$/)),
	})
	.superRefine((data, ctx) => {
		if (data.authType === "gauth" && !data.gauth.trim())
			ctx.addIssue({
				code: "custom",
				path: ["gauth"],
				message: translate("validation.required"),
			});
		if (data.authType === "backup_code" && !data.backup_code.length)
			ctx.addIssue({
				code: "custom",
				path: ["backup_code"],
				message: translate("validation.required"),
			});
	});
